import { useEffect, useState } from "react";

export default function NeuralBackground() {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = [];
    for (let i = 0; i < 8; i++) {
      newParticles.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        delay: Math.random() * 6,
      });
    }
    setParticles(newParticles);
  }, []);

  return (
    <div className="neural-bg">
      <div className="neural-grid" />
      {particles.map((p) => (
        <div
          key={p.id}
          className="floating-particle"
          style={{
            top: `${p.y}%`,
            left: `${p.x}%`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
